/**
 * Provides an API call to fetch available packages.
 * Used to display package options during registration or purchase flows.
 *
 * Exports:
 * - getPackages: Fetches the list of available packages with language support.
 */

// External packages
import { getWithParams } from "../shared/apiPatterns";

// Internal shared modules
import { getLng } from "../../shared/utils/formatting/i18nFormatters";

/**
 * Fetches the list of available packages.
 * Automatically includes the current language parameter based on i18n language.
 *
 * @param {string} [lang] - Optional language code. If not provided, uses current i18n language.
 * @param {string} [context] - Optional context: 'registration' (default) or 'selfcare'.
 * @returns {Promise<Object|null>} The API response JSON, or null on error.
 */
export const getPackages = (lang = null, context = null) => {
  const currentLang = lang || getLng();
  const params = { lang: currentLang };
  if (context) {
    params.context = context;
  }
  return getWithParams("/get-packages", params);
};
